export default class DtoHypeLineTrend {
    constructor(obj) {
        this.coefficient = obj.coefficient
        this.value = obj.value
        this.statisticsType = obj.statisticsType
        this.stationCode = obj.stationCode
        this.parameter = obj.parameter
        this.unit = obj.unit
    }
}